type PermissionMapping = {
    [key: string]: {
        controller: string;
        function: string;
    };
};

export const menumapping: PermissionMapping = {
   'enquiry_menu': {controller: 'enquiry',function: 'enquiryMenu'},
   'quotation_menu' : {controller: 'quotation',function: 'quotationMenu'},
   'saleorder_menu' :  {controller: 'salesorder',function: 'salesOrderMenu'},
   'backorder_menu' :  {controller: 'backorder',function: 'backOrderMenu'},
   'invoice_menu' : {controller: 'invoice',function: 'invoice_menu'},
   'account_recivable_menu' : {controller: 'invoice',function: 'invoiceListingMenu'},
   'paid_invoice_listing_menu' : {controller: 'invoice',function: 'paid_invoice_listing_menu'},
   'rma_menu': {controller: 'rma',function: 'rma_listing_menu'},
   'cancel_so_menu' : {controller: 'salesorder',function: 'cancel_so_listing_menu'},
   'sample_request_menu' : {controller: 'samplerequest',function: 'sample_request'},
   'new_sample_request_menu' : {controller: 'samplerequest',function: 'sample_list'},
   'closed_sample_request_menu' : {controller: 'samplerequest',function: 'closed_sample_listing_page'},
   'cancelled_sample_request_menu' : {controller: 'samplerequest',function: 'cancelled_sample_request_menu'},
   'sales_item_menu' : {controller: 'salesitem',function: 'sales_item'},
   'configuration_menu' : {controller: 'configuration',function: 'configuration_menu'},
    'quotation_submenu' : {controller: 'quotation',function: 'quotationSubMenu'},
    'quotation_approval_submenu' : {controller: 'quotation',function: 'quotationApprovalsubMenu'},
    'sourcing_failed_sample_request_submenu' : {controller: 'samplerequest',function: 'sourcing_failed_sample_requestSubmenu'},
    'sales_pipline_menu' : {controller: 'salesitem',function: 'salespiplineMenu'},
    'sample_inventory_submenu' : {controller: 'samplerequest',function: 'sample_inventory_submenu'},
    'sales_dashboard' : {controller: 'sales',function: 'salesDashboard'},
    'so_awaiting_confirmation_menu' : {controller: 'salesorder',function: 'soAwaitingConfirmationMenu'},
    'vmi_menu': { controller: 'salesorder', function: 'vmi_menu' },

    'quotation_vmi_approval_submenu': { controller: 'quotation', function: 'quotationVmiApprovalSubmenu' },
    'vmi_sample_request_menu': { controller: 'vmisamplerequest', function: 'vmi_sample_request_menu' },
    'vmi_sample_request_listing_menu': { controller: 'vmisamplerequest', function: 'vmi_sample_request_listing_menu' },
    'vmi_closed_sample_request_menu': { controller: 'vmisamplerequest', function: 'vmi_closed_sample_request_menu' },
    'vmi_cancelled_sample_request_menu': { controller: 'vmisamplerequest', function: 'vmi_cancelled_sample_request_menu' }, 

};
